import Loader from 'components/atoms/loader';
import { BiddingDataTypes, ClientDataTypes } from 'interfaces/robot_dashboard';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { fetchRobotDashboardUserBiddings } from 'services/actions/robot_dashboard_actions';
import { useHistory } from 'react-router-dom';
import { datatableColumns, datatableData } from './datatable_list';

interface RobotUserDetailsProps {
  params: {
    id?: string;
  };
}

const RobotUserDetails = (props: RobotUserDetailsProps) => {
  const { params } = props;
  const { id = '' } = params;
  const history = useHistory();

  const [clientData, setClientData] = useState<ClientDataTypes | null>(null);
  const [biddingsData, setBiddingsData] = useState<Array<BiddingDataTypes>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    fetchRobotDashboardUserBiddings(
      id,
      setClientData,
      setBiddingsData,
      setLoading,
      setLoaded,
      setError,
    );
  }, []);

  const customStyles = {
    headCells: {
      style: {
        paddingLeft: '10px',
        paddingRight: '10px',
        fontSize: '14px',
        fontWeight: 'bold',
      },
    },
    cells: {
      style: {
        paddingLeft: '10px',
        paddingRight: '10px',
      },
    },
    rows: {
      style: {
        fontSize: '14px',
      },
    },
  };

  return (
    <div className="page-container">
      <div className="container-fluid big-resolutions p-4">
        {loading && <Loader />}
        {error && <div>Erro ao Carregar Dados</div>}
        {loaded && (
          <>
            <div className="row mb-3">
              <div className="col-12">
                <button
                  type="button"
                  className="btn btn-link p-0 m-0 border-0 d-flex"
                  onClick={() => {
                    history.goBack();
                  }}
                >
                  <i className="material-icons align-middle">keyboard_arrow_left</i> Voltar
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <h4>{clientData?.companyName}</h4>
                <div>
                  <p>{clientData?.clientId}</p>
                  <p>{clientData?.cnpj}</p>
                </div>

                {biddingsData && (
                  <DataTable
                    columns={datatableColumns()}
                    data={datatableData(biddingsData)}
                    customStyles={customStyles}
                    noDataComponent={
                      <div className="p-5">Nenhuma licitação para este usuário.</div>
                    }
                  />
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default RobotUserDetails;
